import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import {
  ReadingMaterialError,
  ReadingMaterialInput,
  ReadingMaterialProps,
  stateStatusType,
} from "../store/actionType";
import ReadingMaterialForm from "./components/ReadingMaterialForm";
import { connect, useSelector } from "react-redux";
import { createReadingMaterial, updateReadingMaterial } from "../store/action";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";
import { ApiError } from "components";
interface OwnProps {
  onClose: () => void;
  rMData: ReadingMaterialProps;
  videoId: string;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateReadingMaterial: React.FC<Props> = ({
  onClose,
  rMData,
  onUpdateRM,
  videoId,
}) => {
  const readingMaterialState = useSelector(
    (state: any) => state.readingMaterial?.readingMaterialState
  );
  const [formData, setFormData] = useState<ReadingMaterialInput>({
    description: rMData?.description,
    pdf: rMData?.pdf ?? "",
    name: rMData?.name,
    video_id: rMData?.video_id,
  });
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ReadingMaterialError>({});
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, files } = e.target as HTMLInputElement;

    if (name === "pdf" && files && files.length > 0) {
      const file = files[0];
      setFormData((prev) => ({
        ...prev,
        pdfFile: file,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (formData.description.trim() === "") {
      setError({ description: "Description is required" });
      return;
    }
    if (formData.name.trim() === "") {
      setError({ name: "name is required" });
      return;
    }
    let uploadedFilename: string | undefined = undefined;
    if (formData.pdfFile) {
      const uploadUrl = `${process.env.REACT_APP_PDF_UPLOAD_BASE_URL}`;
      const form = new FormData();
      form.append("file", formData.pdfFile);
      const response = await fetch(uploadUrl ?? "", {
        method: "POST",
        body: form,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Failed to upload pdf");
      }

      const result = await response.json();
      uploadedFilename = result?.pdfUrl;

      if (!uploadedFilename) {
        console.error("Pdf upload response invalid", result);
        throw new Error("Pdf upload response invalid");
      }
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      const input: ReadingMaterialInput = {
        description: formData.description,
        name: formData.name,
        video_id: videoId,
      };
      if (uploadedFilename) {
        input.pdf = uploadedFilename;
      }
      setLoading(true);
      setSubmitted(true);
      onUpdateRM(input, rMData?.id?.toString());
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!submitted) return;

    if (readingMaterialState.isLoading) return;

    if (readingMaterialState.status === stateStatusType.SUCCESS) {
      setApiError(null);
    }

    if (readingMaterialState.status === stateStatusType.FAILED) {
      setApiError(readingMaterialState.error || "Failed to create questions.");
    }

    setSubmitted(false);
  }, [readingMaterialState, submitted]);
  useEffect(() => {
    if (formData?.pdf && typeof formData?.pdf !== "string") {
      const fileUrl = URL.createObjectURL(formData?.pdf);
      setPreviewUrl(fileUrl);
      return () => URL.revokeObjectURL(fileUrl);
    }
  }, [formData?.pdfFile]);

  return (
    <>
      <ReadingMaterialForm
        header="Update Reading Material"
        onClose={onClose}
        rMData={rMData}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        loading={loading}
        error={error}
        previewUrl={previewUrl}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateRM: (input: ReadingMaterialInput, materialId: string) =>
    dispatch(updateReadingMaterial(input, materialId)),
});

export default connect(null, mapDispatchToProps)(HandleUpdateReadingMaterial);
